
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import {
PageContainer,
PageHeader,
PageContent,
PageFooter,
SaafHeader
} from '@/common/components/index'

export default {
data () {
return {
}
},
components: {
Grid,
GridItem,
XButton,
PageContainer,
PageHeader,
PageContent,
PageFooter,
SaafHeader
},
computed: {

},

methods: {

},
created(){

},
mounted(){

},
}





// WEBPACK FOOTER //
// ./src/page/srm/demo/DevHome.vue